import { BottomTabNavigationProp } from '@react-navigation/bottom-tabs'
import { CompositeNavigationProp } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { Colors, Theme } from '@rneui/themed'
import { ConversationTabParamList } from 'chat/conversations/types'
import { FileFoldersBottomTabParamList } from 'file_folder_repository/chat_group_folders/stack/types'
import { HomeStackParamList } from 'home/stack/types'
import { Platform } from 'react-native'
import { showHeaderButton } from 'shared/header/header_button'

export function showShareHeaderButton<
  RouteName extends keyof HomeStackParamList
>({
  navigation,
  theme,
  onPress,
  position = 'right',
  loading,
}: {
  navigation:
    | StackNavigationProp<HomeStackParamList, RouteName>
    | CompositeNavigationProp<
        | BottomTabNavigationProp<ConversationTabParamList>
        | BottomTabNavigationProp<FileFoldersBottomTabParamList>,
        StackNavigationProp<HomeStackParamList>
      >
  theme: {
    colors: Colors
  } & Theme
  onPress: () => void
  loading?: boolean
  position?: 'left' | 'right'
}) {
  return showHeaderButton({
    navigation,
    theme,
    title: Platform.OS === 'ios' ? 'share-apple' : 'share-google',
    onPress,
    position,
    useIcon: true,
    iconType: 'evilicon',
    loading,
  })
}
